module.exports = __webpack_public_path__ + "static/media/thermoready-logo.7b18e7f6.jpg";